import {createPaginationContainer, graphql} from 'react-relay';

const ProjectLoader = ({relay: {hasMore, isLoading, loadMore}, viewer, children, ...props}) => {
	const formatData = () => {
		return viewer.company.financialBasedProjects.edges.map(project => {
			const {financialNumbers} = project.node;
			return {
				project: {
					...project.node,
				},
				currency: viewer.company.currency,
				financialNumbers: {
					...financialNumbers,
				},
			};
		});
	};
	const loadMoreFunc = hasMore() ? loadMore : undefined;
	return children({data: {rows: formatData()}, loadMore: loadMoreFunc, loading: isLoading(), ...props});
};

export const projectLoaderQuery = graphql`
	query ProjectLoader_Query(
		$startYear: Int!
		$startMonth: Int!
		$startDay: Int!
		$endYear: Int!
		$endMonth: Int!
		$endDay: Int!
		$searchQuery: TaskSearchQueryType!
		$pageSize: Int!
		$cursor: String
	) {
		viewer {
			actualPersonId
			component(name: "project_portfolio_period_project_loader")
			...ProjectLoader_viewer
				@arguments(
					searchQuery: $searchQuery
					pageSize: $pageSize
					cursor: $cursor
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
				)
		}
	}
`;

export default createPaginationContainer(
	ProjectLoader,
	{
		viewer: graphql`
			fragment ProjectLoader_viewer on Viewer
			@argumentDefinitions(
				searchQuery: {type: "TaskSearchQueryType!"}
				startYear: {type: "Int!"}
				startMonth: {type: "Int!"}
				startDay: {type: "Int!"}
				endYear: {type: "Int!"}
				endMonth: {type: "Int!"}
				endDay: {type: "Int!"}
				pageSize: {type: "Int!"}
				cursor: {type: "String"}
			) {
				id
				company {
					currency
					financialBasedProjects(
						searchQuery: $searchQuery
						startYear: $startYear
						startMonth: $startMonth
						startDay: $startDay
						endYear: $endYear
						endMonth: $endMonth
						endDay: $endDay
						first: $pageSize
						after: $cursor
					) @connection(key: "Company_financialBasedProjects") {
						edges {
							node {
								id
								companyProjectId
								name
								budgetType
								budgetBaseCurrency
								defaultPeriodBudgetType
								fullAccessToProject
								projectColor
								status
								projectStartDay
								projectStartMonth
								projectStartYear
								projectEndDay
								projectEndMonth
								projectEndYear
								baselineWinChance
								useBaseline
								estimationUnit
								progressEndOfTheMonth
								completion
								rateCard {
									id
									name
									currency
									parentRateCardId
								}
								client {
									id
									name
									logoId
									logoDefaultId
								}
								projectLabels(first: 1000) {
									edges {
										node {
											label {
												name
												color
											}
										}
									}
								}
								projectPersons(first: 1000000, contactsOnly: true) {
									edges {
										node {
											id
											isContactPerson
											person {
												id
												fullName
												firstName
												lastName
												profilePictureId
												profilePictureDefaultId
												initials
											}
										}
									}
								}
								currentProjectStatus {
									id
									color
									person {
										id
										firstName
										lastName
										fullName
										profilePictureId
									}
								}
								financialNumbers(
									startYear: $startYear
									startMonth: $startMonth
									startDay: $startDay
									endYear: $endYear
									endMonth: $endMonth
									endDay: $endDay
								) {
									actualRevenue
									actualCost
									actualProfit
									actualMargin
									plannedRevenue
									plannedCost
									plannedProfit
									plannedMargin
									remainingRevenue
									remainingCost
									remainingProfit
									remainingMargin
									forecastRevenue
									forecastCost
									forecastProfit
									forecastMargin
									baselineRevenue
									baselineCost
									baselineProfit
									baselineMargin
									baselineMinutes
									actualVsPlanRevenue
									actualVsPlanCost
									actualVsPlanProfit
									forecastVsPlanRevenue
									forecastVsPlanCost
									forecastVsPlanProfit
									registeredMinutes
									remainingMinutes
									forecastMinutes
									scopeApprovedMinutes
									scopeTotalMinutes
									allocationMinutes
									invoiced
									paid
									invoicedVsActualRevenue
									retainerPeriodTargetMinutes
									retainerPeriodTargetPrice
								}
							}
						}
					}
				}
			}
		`,
	},
	{
		direction: 'forward',
		getConnectionFromProps({viewer}) {
			return viewer.company.financialBasedProjects;
		},
		getFragmentVariables(prevVars) {
			return {
				...prevVars,
			};
		},
		getVariables(_, {cursor}, fragmentVariables) {
			return {
				...fragmentVariables,
				cursor,
			};
		},
		query: graphql`
			query ProjectLoaderRefetchQuery(
				$startYear: Int!
				$startMonth: Int!
				$startDay: Int!
				$endYear: Int!
				$endMonth: Int!
				$endDay: Int!
				$searchQuery: TaskSearchQueryType!
				$pageSize: Int!
				$cursor: String
			) {
				viewer {
					actualPersonId
					component(name: "project_portfolio_period_project_loader")
					...ProjectLoader_viewer
						@arguments(
							searchQuery: $searchQuery
							pageSize: $pageSize
							cursor: $cursor
							startYear: $startYear
							startMonth: $startMonth
							startDay: $startDay
							endYear: $endYear
							endMonth: $endMonth
							endDay: $endDay
						)
				}
			}
		`,
	}
);
